import { render, staticRenderFns } from "./AccountDomainForm.vue?vue&type=template&id=546c0f7c&scoped=true"
import script from "./AccountDomainForm.vue?vue&type=script&lang=js"
export * from "./AccountDomainForm.vue?vue&type=script&lang=js"
import style0 from "./AccountDomainForm.vue?vue&type=style&index=0&id=546c0f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c0f7c",
  null
  
)

export default component.exports